export default "__VITE_ASSET__BXC81gcB__"